<template>
  <div class="is-marginless">
    <data-selector
      right-icon="chevron-down"
      searchable
      v-model="selectedZoneId"
      :disabled="!zones.length"
      :items="zones"
      value-key="id"
      label-key="name">
      <template slot="item" slot-scope="{ item }">
        <span :class="{ 'has-text-grey-light': !item.compatible }">{{ item.name }}</span>
        <span v-if="!item.compatible" class="tag is-light ml-1">Incompatible {{ Naming.AssetType.toLowerCase() }}</span>
      </template>
      <action-button
        class="is-primary"
        v-if="selectedZoneId"
        slot="right"
        @click="clearZone()">
        <icon icon="times"/>
      </action-button>Select {{ Naming.Zone }} to Transfer {{ Naming.Asset }} To
    </data-selector>
    <div v-if="!loadingZones && selectedSite && zones.length < 1">
      <message class="is-danger">
        The {{ selectedSite.name }} {{ Naming.Site.toLowerCase() }} does not have any {{ Naming.Zones.toLowerCase() }}. <br>
        <router-link class="button is-danger mt-1"
          :to="{ name: 'zone-create', params: { site: selectedSite.id }}">
          <span>Add {{ Naming.Zone }}</span>
          <icon icon="chevron-right"/>
        </router-link>
      </message>
    </div>  
    <div v-if="!loadingZones && selectedSite && zones.length > 0 && compatibleZones.length < 1">
      <message class="is-danger">
        The {{ selectedSite.name }} {{ Naming.Site.toLowerCase() }} does not have any {{ Naming.Zones.toLowerCase() }} that allow this {{ Naming.Asset.toLowerCase() }}'s {{ Naming.AssetType.toLowerCase() }}.
        <br>
        <router-link class="button is-danger mt-1"
          :to="{ name: 'site-zones', params: { site: selectedSite.id }}">
          <span>Configure {{ Naming.Zones }}</span>
          <icon icon="chevron-right"/>
        </router-link>
      </message>
    </div>   
  </div> 
</template>

<script>

export default {

  props: {
    selectedSite: {
      type: Object,
      default: () => {}
    },
    zones: {
      type: Array,
      default: () => []
    },
    loadingZones: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    selectedZoneId : null,
  }),

  methods: {
    clearZone(){
      this.selectedZoneId = null
    }
  },

  computed: {
    selectedZone(){
      return _.find(this.zones, zone => zone.id === this.selectedZoneId) ?? null
    },
    compatibleZones() {
      return _.filter(this.zones, zone => zone.compatible)
    },
  },

  watch: {
    selectedZoneId() {
      if (this.selectedZone !== null && !this.selectedZone.compatible) {
        this.$toast.error(`This ${this.Naming.Zone.toLowerCase()} does not allow this ${this.Naming.Asset.toLowerCase()}'s ${this.Naming.AssetType.toLowerCase()}.`)
        this.selectedZoneId = null
        return
      }
      this.$emit('zoneSelected', this.selectedZone)
    },
  },  
}
</script>
